import { render } from "./LayoutEN.vue?vue&type=template&id=2d337afe&scoped=true"
import script from "./LayoutEN.vue?vue&type=script&lang=js"
export * from "./LayoutEN.vue?vue&type=script&lang=js"

import "./LayoutEN.vue?vue&type=style&index=0&id=2d337afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d337afe"]])

export default __exports__